import { render, staticRenderFns } from "./ClassroomAttachmentCreate.vue?vue&type=template&id=492d6af1&scoped=true&"
import script from "./ClassroomAttachmentCreate.vue?vue&type=script&lang=js&"
export * from "./ClassroomAttachmentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d6af1",
  null
  
)

export default component.exports